// Persian Poetry from the Greatest Persian Poets
// شعرهای کلاسیک ایران از بزرگ‌ترین شاعران ایرانی

export const persianPoems = [
  {
  title: "شاهنامه – آغاز خرد",
  poet: "Ferdowsi",
  poet_bio_fa: "ابوالقاسم فردوسی شاعر حماسی قرن چهارم هجری و خالق شاهنامه است که نقش بنیادینی در حفظ زبان فارسی دارد.",
  poet_bio_en: "Ferdowsi was a 10th-century Persian epic poet and author of the Shahnameh, crucial to preserving Persian language.",
  poem: `به نام خداوند جان و خرد
کزین برتر اندیشه برنگذرد
خداوند نام و خداوند جای
خداوند روزی‌ده رهنمای`,
  analysis_fa: "فردوسی خرد را پایه آفرینش و معیار برتری انسان معرفی می‌کند.",
  analysis_en: "Ferdowsi presents wisdom as the foundation of creation and human superiority.",
  icon: "🧠"
},
{
  title: "شاهنامه – دادگری",
  poet: "Ferdowsi",
  poet_bio_fa: "اندیشه سیاسی فردوسی بر عدالت و داد استوار است.",
  poet_bio_en: "Ferdowsi’s political thought centers on justice.",
  poem: `ز داد و دهش یافت آن نیک‌نام
تو داد و دهش کن فریدون‌صفت
نباشد همی نیک و بد پایدار
همان به که نیکی بود یادگار`,
  analysis_fa: "دادگری عامل جاودانگی نام انسان معرفی می‌شود.",
  analysis_en: "Justice is shown as the source of lasting honor.",
  icon: "⚖️"
},
{
  title: "شاهنامه – گذر عمر",
  poet: "Ferdowsi",
  poet_bio_fa: "فردوسی به ناپایداری دنیا آگاه است.",
  poet_bio_en: "Ferdowsi acknowledges the impermanence of the world.",
  poem: `جهان یادگار است و ما رفتنی
به گیتی نماند به جز مردمی
چو خواهی که نامت بود جاودان
مکن جز به نیکی به گیتی زیان`,
  analysis_fa: "اخلاق نیک تنها راه ماندگاری انسان است.",
  analysis_en: "Moral virtue is the only path to permanence.",
  icon: "⏳"
},
{
  title: "شاهنامه – خرد شاهی",
  poet: "Ferdowsi",
  poet_bio_fa: "در شاهنامه، پادشاهی بدون خرد محکوم به زوال است.",
  poet_bio_en: "Kingship without wisdom is doomed in the Shahnameh.",
  poem: `خرد چشم جان است چون بنگری
تو بی‌چشم شادان جهان نسپری
نخست آفرینش خرد را شناس
نگهبان جان است و آن را سپاس`,
  analysis_fa: "خرد راهنمای قدرت و سیاست است.",
  analysis_en: "Wisdom guides power and governance.",
  icon: "👑"
},
{
  title: "شاهنامه – مرگ",
  poet: "Ferdowsi",
  poet_bio_fa: "مرگ در نگاه فردوسی حقیقتی گریزناپذیر است.",
  poet_bio_en: "Death is an inevitable truth in Ferdowsi’s worldview.",
  poem: `همه کار دنیا به نوبت بود
جهان را نه آغاز و نه منت بود
چو مرگ آیدت هیچ چاره نماند
نه تخت و نه تاج و نه زر برنماند`,
  analysis_fa: "قدرت دنیوی در برابر مرگ بی‌ارزش است.",
  analysis_en: "Worldly power is meaningless before death.",
  icon: "⚰️"
},
{
  title: "شاهنامه – نام نیک",
  poet: "Ferdowsi",
  poet_bio_fa: "نام نیک جوهره اخلاق فردوسی است.",
  poet_bio_en: "Good reputation is central to Ferdowsi’s ethics.",
  poem: `بماند ز ما نام نیک ار بماند
ز بد نامی ما نماند جز گزند
کسی کو خرد را کند پیشه‌ور
به نیکی بماند پس از مرگ بر`,
  analysis_fa: "انسان با کردار نیک جاودانه می‌شود.",
  analysis_en: "Humans achieve immortality through good deeds.",
  icon: "🌟"
},
{
  title: "شاهنامه – میهن",
  poet: "Ferdowsi",
  poet_bio_fa: "میهن‌دوستی رکن اصلی شاهنامه است.",
  poet_bio_en: "Patriotism is a core theme of the Shahnameh.",
  poem: `چو ایران نباشد تن من مباد
بر این بوم و بر زنده یک تن مباد
همه سر به سر تن به کشتن دهیم
از آن به که کشور به دشمن دهیم`,
  analysis_fa: "ایران به‌مثابه هویت جمعی مطرح می‌شود.",
  analysis_en: "Iran is portrayed as collective identity.",
  icon: "🏹"
},
{
  title: "شاهنامه – سرنوشت",
  poet: "Ferdowsi",
  poet_bio_fa: "فردوسی تقدیر را بخشی از نظم جهان می‌داند.",
  poet_bio_en: "Fate is part of cosmic order in Ferdowsi’s view.",
  poem: `چنین است آیین گردان سپهر
گهی شاد دارد گهی پر ز مهر
نه کس را بدین راز راهی بود
نه اندیشه را سویش آگاهی بود`,
  analysis_fa: "انسان در برابر تقدیر محدود است.",
  analysis_en: "Human control over fate is limited.",
  icon: "🌀"
},
{
  title: "شاهنامه – دانش",
  poet: "Ferdowsi",
  poet_bio_fa: "دانش در شاهنامه برتر از زور است.",
  poet_bio_en: "Knowledge surpasses brute force in the Shahnameh.",
  poem: `توانا بود هر که دانا بود
ز دانش دل پیر برنا بود
ز دانش دل شاه روشن شود
به گیتی ز هر بد ایمن شود`,
  analysis_fa: "دانایی عامل توانمندی واقعی است.",
  analysis_en: "Knowledge is the source of true power.",
  icon: "📘"
},
{
  title: "شاهنامه – غرور",
  poet: "Ferdowsi",
  poet_bio_fa: "غرور عامل سقوط قهرمانان است.",
  poet_bio_en: "Pride leads to downfall in Ferdowsi’s narratives.",
  poem: `چو بگذاشتی پای از اندازه بیش
به گردون رسیدی ز کردار خویش
سرانجام کبر و منی خاک بود
دل روشن از کینه ناک بود`,
  analysis_fa: "خودبینی انسان را به نابودی می‌کشاند.",
  analysis_en: "Arrogance results in destruction.",
  icon: "⚠️"
},
{
  title: "شاهنامه – وفاداری",
  poet: "Ferdowsi",
  poet_bio_fa: "وفاداری ارزش بنیادین پهلوانی است.",
  poet_bio_en: "Loyalty is a fundamental heroic value.",
  poem: `به پیمان مکن هیچ‌گه سست پشت
که پیمان شکستن بود ننگ و زشت
وفادار مردان به گیتی کمند
ولیکن به نام اندرون بیشمند`,
  analysis_fa: "پیمان‌داری نشانه شرافت است.",
  analysis_en: "Keeping one’s word defines honor.",
  icon: "🛡️"
},
{
  title: "شاهنامه – خرد جمعی",
  poet: "Ferdowsi",
  poet_bio_fa: "رای و مشورت ارزشمند شمرده می‌شود.",
  poet_bio_en: "Consultation and counsel are valued.",
  poem: `چو کاری بزرگ آیدت پیش رو
خرد را مکن هیچ‌گه گفت‌وگو
ز دانا بپرس و ز نادان مپرس
که راه تو گردد ز تاریکی درس`,
  analysis_fa: "مشورت راه رهایی از خطاست.",
  analysis_en: "Counsel prevents error.",
  icon: "👥"
},
{
  title: "شاهنامه – قدرت",
  poet: "Ferdowsi",
  poet_bio_fa: "قدرت بدون اخلاق بی‌ارزش است.",
  poet_bio_en: "Power without ethics is worthless.",
  poem: `نه تخت و نه تاج آن کند مرد را
که داد و خرد زنده دارد ورا
چو داد از جهان رخت بندد به زور
نماند به گیتی نه نام و نه شور`,
  analysis_fa: "مشروعیت قدرت از عدالت می‌آید.",
  analysis_en: "Legitimate power stems from justice.",
  icon: "🏛️"
},
{
  title: "شاهنامه – زندگی",
  poet: "Ferdowsi",
  poet_bio_fa: "زندگی میدان آزمون اخلاق است.",
  poet_bio_en: "Life is a moral testing ground.",
  poem: `جهان سر به سر عبرت و حکمت است
چرا بهره ما همه غفلت است
اگر نیک بنگری اندر جهان
نیابی به جز درد و رنج نهان`,
  analysis_fa: "انسان باید از جهان درس بگیرد.",
  analysis_en: "The world exists to teach wisdom.",
  icon: "🌍"
},
{
  title: "شاهنامه – پایان سخن",
  poet: "Ferdowsi",
  poet_bio_fa: "فردوسی جاودانگی را در سخن می‌بیند.",
  poet_bio_en: "Ferdowsi sees immortality in words.",
  poem: `بسی رنج بردم در این سال سی
عجم زنده کردم بدین پارسی
نمیرم از این پس که من زنده‌ام
که تخم سخن را پراکنده‌ام`,
  analysis_fa: "شعر وسیله بقا و هویت فرهنگی است.",
  analysis_en: "Poetry becomes a means of cultural immortality.",
  icon: "📜"
},
{
  title: "مثنوی – نی‌نامه",
  poet: "Rumi",
  poet_bio_fa: "مولانا جلال‌الدین رومی شاعر و عارف قرن هفتم هجری است که اندیشه‌اش بر عشق الهی و سلوک باطنی استوار است.",
  poet_bio_en: "Rumi was a 13th-century Persian mystic poet whose thought centers on divine love and inner journey.",
  poem: `بشنو از نی چون حکایت می‌کند
از جدایی‌ها شکایت می‌کند
کز نیستان تا مرا ببریده‌اند
در نفیرم مرد و زن نالیده‌اند`,
  analysis_fa: "نی نماد روح جداشده از اصل الهی و درد فراق است.",
  analysis_en: "The reed symbolizes the soul separated from its divine origin.",
  icon: "🎶"
},
{
  title: "مثنوی – عشق",
  poet: "Rumi",
  poet_bio_fa: "مولانا عشق را جوهر هستی می‌داند.",
  poet_bio_en: "Rumi views love as the essence of existence.",
  poem: `عشق آمد و شد چو خونم اندر رگ و پوست
تا کرد مرا تهی و پر کرد ز دوست
عشق آن شمعی‌ست کز افروختنش
جز سوختن خویش نیاید درست`,
  analysis_fa: "عشق خود را می‌سوزاند تا حقیقت را آشکار کند.",
  analysis_en: "Love consumes the self to reveal truth.",
  icon: "🔥"
},
{
  title: "مثنوی – خودشناسی",
  poet: "Rumi",
  poet_bio_fa: "خودشناسی در اندیشه مولانا مقدمه خداشناسی است.",
  poet_bio_en: "Self-knowledge is the path to divine knowledge in Rumi’s thought.",
  poem: `ای برادر تو همان اندیشه‌ای
مابقی تو استخوان و ریشه‌ای
گر گل است اندیشه تو گلشنی
ور بود خاری تو هیمه گلخنی`,
  analysis_fa: "هویت انسان با اندیشه‌های او تعریف می‌شود.",
  analysis_en: "Human identity is defined by thought.",
  icon: "🧩"
},
{
  title: "مثنوی – صبر",
  poet: "Rumi",
  poet_bio_fa: "صبر از ارکان سلوک عرفانی مولاناست.",
  poet_bio_en: "Patience is central to Rumi’s mystical path.",
  poem: `صبر تلخ است و لیکن بر شیرین دهد
صبر کن کاین تلخی‌ات را چین دهد
هر که صبر آورد گردون‌وار شد
هر که ناصبر است او خوار شد`,
  analysis_fa: "صبر مسیر تعالی روح است.",
  analysis_en: "Patience leads to spiritual elevation.",
  icon: "⏳"
},
{
  title: "مثنوی – عقل و عشق",
  poet: "Rumi",
  poet_bio_fa: "مولانا عقل جزوی را محدود می‌داند.",
  poet_bio_en: "Rumi considers partial intellect limited.",
  poem: `عقل در شرحش چو خر در گل بخفت
شرح عشق و عاشقی هم عشق گفت
عقل چون شمشیر تیز است ای پسر
لیک بی‌عشق است چو تیغی بی‌هنر`,
  analysis_fa: "عشق فراتر از عقل تحلیلی است.",
  analysis_en: "Love transcends analytical reason.",
  icon: "⚔️"
},
{
  title: "مثنوی – مرگ",
  poet: "Rumi",
  poet_bio_fa: "مرگ در نگاه مولانا تولدی دوباره است.",
  poet_bio_en: "Death is rebirth in Rumi’s worldview.",
  poem: `مرگ اگر مرد است گو نزد من آی
تا در آغوشش بگیرم تنگ تنگ
من از او جانی ستانم جاودان
او ز من دلقی ستاند رنگ‌رنگ`,
  analysis_fa: "مرگ رهایی از قفس تن است.",
  analysis_en: "Death liberates the soul from bodily confinement.",
  icon: "🕊️"
},
{
  title: "مثنوی – وحدت",
  poet: "Rumi",
  poet_bio_fa: "وحدت وجود محور اندیشه مولاناست.",
  poet_bio_en: "Unity of being is central to Rumi’s philosophy.",
  poem: `چون یکی بینی تو ذرات جهان
همچو خورشیدی درخشان در میان
این همه نقش خیال است ای پسر
چشم بگشا تا ببینی اصل را`,
  analysis_fa: "کثرت ظاهری و وحدت باطنی بیان می‌شود.",
  analysis_en: "Apparent multiplicity conceals inner unity.",
  icon: "🌐"
},
{
  title: "مثنوی – خاموشی",
  poet: "Rumi",
  poet_bio_fa: "خاموشی راه درک حقیقت است.",
  poet_bio_en: "Silence leads to truth.",
  poem: `چون قلم اندر نوشتن می‌شکافت
چون به عشق آمد قلم بر خود شتافت
چون سخن در عشق گفتن می‌رسد
هم قلم بشکست هم کاغذ درید`,
  analysis_fa: "حقیقت فراتر از زبان است.",
  analysis_en: "Truth transcends language.",
  icon: "🤫"
},
{
  title: "مثنوی – توکل",
  poet: "Rumi",
  poet_bio_fa: "توکل عامل آرامش درونی است.",
  poet_bio_en: "Trust in the divine brings inner peace.",
  poem: `کار خود گر بر خدا بسپرده‌ای
در دل آرامی و دل‌آزرده‌ای
چون سپردی کار خود را بی‌گمان
کارها آید به سامان و امان`,
  analysis_fa: "سپردن امور به خدا آرامش می‌آورد.",
  analysis_en: "Surrendering to God brings order and peace.",
  icon: "🕊️"
},
{
  title: "مثنوی – انسان",
  poet: "Rumi",
  poet_bio_fa: "انسان آینه حقیقت الهی است.",
  poet_bio_en: "Humans are mirrors of divine truth.",
  poem: `این جهان کوه است و فعل ما ندا
سوی ما آید نداها را صدا
چون تو در کوه آواز افکنی
بازگردد سوی تو آواز نی`,
  analysis_fa: "رفتار انسان بازتابی جهانی دارد.",
  analysis_en: "Human actions echo back universally.",
  icon: "🪞"
},
{
  title: "مثنوی – آگاهی",
  poet: "Rumi",
  poet_bio_fa: "آگاهی رهایی‌بخش است.",
  poet_bio_en: "Awareness brings liberation.",
  poem: `خفته آن باشد که او از هر خیال
دارد امیدی و بیند هر محال
چشم بگشا تا ببینی راه خویش
زانکه در خواب است جانت ای رفیق`,
  analysis_fa: "غفلت مانع رهایی روح است.",
  analysis_en: "Ignorance hinders spiritual freedom.",
  icon: "👁️"
},
{
  title: "مثنوی – دل",
  poet: "Rumi",
  poet_bio_fa: "دل جایگاه حقیقت است.",
  poet_bio_en: "The heart is the seat of truth.",
  poem: `دل نباشد جز محل نظر خدا
خانه‌ای کز غیر خالی شد رها
هر کجا دل پاک و روشن شد ز غیر
آنجا آید جلوه معشوق سیر`,
  analysis_fa: "پاکی دل شرط وصال است.",
  analysis_en: "Purity of heart enables union.",
  icon: "❤️"
},
{
  title: "مثنوی – رهایی",
  poet: "Rumi",
  poet_bio_fa: "رهایی در بریدن از وابستگی‌هاست.",
  poet_bio_en: "Freedom lies in detachment.",
  poem: `بنده آن باشد که بند خویش دید
خویش را از بند دنیا برکشید
هر که بندد دل به این دنیا فریب
می‌برد جانش به زندان غریب`,
  analysis_fa: "وابستگی مانع آزادی است.",
  analysis_en: "Attachment prevents freedom.",
  icon: "🔓"
},
{
  title: "مثنوی – حقیقت",
  poet: "Rumi",
  poet_bio_fa: "حقیقت در درون انسان نهفته است.",
  poet_bio_en: "Truth resides within humans.",
  poem: `گنج در خانه و ما گرد جهان
می‌دوانیم به هر سو ناتوان
چون درون خانه بنگری ای پسر
گنج آنجاست نه بیرون ز در`,
  analysis_fa: "انسان حقیقت را در بیرون می‌جوید.",
  analysis_en: "Humans search outward for inner truth.",
  icon: "💎"
},
{
  title: "مثنوی – پایان راه",
  poet: "Rumi",
  poet_bio_fa: "بازگشت به اصل، پایان سلوک است.",
  poet_bio_en: "Returning to the origin is the end of the path.",
  poem: `بازآ بازآ هر آنچه هستی بازآ
گر کافر و گبر و بت‌پرستی بازآ
این درگه ما درگه نومیدی نیست
صد بار اگر توبه شکستی بازآ`,
  analysis_fa: "رحمت الهی بی‌مرز و همگانی است.",
  analysis_en: "Divine mercy is boundless and universal.",
  icon: "🌟"
},
{
  title: "دیوان حافظ – میخانه",
  poet: "Hafez",
  poet_bio_fa: "حافظ شیرازی شاعر قرن هشتم هجری و استاد غزل عرفانی با زبانی نمادین و چندلایه است.",
  poet_bio_en: "Hafez was a 14th-century Persian master of mystical ghazals with rich symbolic language.",
  poem: `دوش دیدم که ملائک در میخانه زدند
گل آدم بسرشتند و به پیمانه زدند
ساکنان حرم ستر و عفاف ملکوت
با من راه‌نشین باده مستانه زدند`,
  analysis_fa: "حافظ پیوند خاک و افلاک را با نماد میخانه و شراب نشان می‌دهد.",
  analysis_en: "Hafez symbolically unites the earthly and divine through wine imagery.",
  icon: "🍷"
},
{
  title: "دیوان حافظ – رندی",
  poet: "Hafez",
  poet_bio_fa: "رندی در شعر حافظ راه رهایی از ریا و تظاهر است.",
  poet_bio_en: "Rendi represents liberation from hypocrisy in Hafez’s poetry.",
  poem: `عیب رندان مکن ای زاهد پاکیزه‌سرشت
که گناه دگران بر تو نخواهند نوشت
من اگر نیکم و گر بد تو برو خود را باش
هر کسی آن درود عاقبت کار که کشت`,
  analysis_fa: "حافظ قضاوت اخلاقی سطحی را نقد می‌کند.",
  analysis_en: "Hafez criticizes superficial moral judgment.",
  icon: "🎭"
},
{
  title: "دیوان حافظ – امید",
  poet: "Hafez",
  poet_bio_fa: "امید به رحمت الهی مضمون تکرارشونده در شعر حافظ است.",
  poet_bio_en: "Hope in divine mercy is a recurring theme in Hafez’s work.",
  poem: `یوسف گمگشته بازآید به کنعان غم مخور
کلبه احزان شود روزی گلستان غم مخور
ای دل غمدیده حالت به شود دل بد مکن
وین سر شوریده بازآید به سامان غم مخور`,
  analysis_fa: "شعر نوید رهایی پس از رنج را می‌دهد.",
  analysis_en: "The poem promises relief and restoration after hardship.",
  icon: "🌱"
},
{
  title: "دیوان حافظ – عشق",
  poet: "Hafez",
  poet_bio_fa: "عشق در شعر حافظ نیرویی ویرانگر و نجات‌بخش است.",
  poet_bio_en: "Love in Hafez is both destructive and salvific.",
  poem: `در ازل پرتو حسنت ز تجلی دم زد
عشق پیدا شد و آتش به همه عالم زد
جلوه‌ای کرد رخت دید ملک عشق نداشت
عین آتش شد از این غیرت و بر آدم زد`,
  analysis_fa: "عشق نیروی آغازین آفرینش معرفی می‌شود.",
  analysis_en: "Love is presented as the primal force of creation.",
  icon: "🔥"
},
{
  title: "دیوان حافظ – بی‌ثباتی دنیا",
  poet: "Hafez",
  poet_bio_fa: "حافظ ناپایداری جهان را با زبانی شاعرانه بیان می‌کند.",
  poet_bio_en: "Hafez poetically expresses the impermanence of the world.",
  poem: `چو بشنوی سخن اهل دل مگو که خطاست
سخن‌شناس نه‌ای جان من خطا اینجاست
سرم به دنیی و عقبی فرو نمی‌آید
تبارک‌الله از این فتنه‌ها که در سر ماست`,
  analysis_fa: "دل‌بستگی به دنیا مانع درک حقیقت است.",
  analysis_en: "Worldly attachment obstructs understanding truth.",
  icon: "🌍"
},
{
  title: "بوستان – انسانیت",
  poet: "Saadi",
  poet_bio_fa: "سعدی شیرازی شاعر قرن هفتم هجری و از بزرگ‌ترین اندرزگویان ادب فارسی است.",
  poet_bio_en: "Saadi was a 13th-century Persian poet renowned for ethical and humanistic teachings.",
  poem: `بنی‌آدم اعضای یک پیکرند
که در آفرینش ز یک گوهرند
چو عضوی به درد آورد روزگار
دگر عضوها را نماند قرار`,
  analysis_fa: "سعدی وحدت وجودی انسان‌ها و مسئولیت اخلاقی متقابل را بیان می‌کند.",
  analysis_en: "Saadi emphasizes human unity and shared moral responsibility.",
  icon: "🤝"
},
{
  title: "گلستان – قناعت",
  poet: "Saadi",
  poet_bio_fa: "قناعت و میانه‌روی از مفاهیم کلیدی اندیشه سعدی است.",
  poet_bio_en: "Contentment is a core concept in Saadi’s philosophy.",
  poem: `قناعت توانگر کند مرد را
خبر کن حریص جهانگرد را
چو چشم حرص تنگ شد بر قناعت
شود شاه اگر داشت نان و نبات`,
  analysis_fa: "قناعت منبع آرامش و بی‌نیازی است.",
  analysis_en: "Contentment brings peace and independence.",
  icon: "🍞"
},
{
  title: "بوستان – تربیت",
  poet: "Saadi",
  poet_bio_fa: "سعدی تربیت اخلاقی را زیربنای جامعه سالم می‌داند.",
  poet_bio_en: "Saadi views moral education as the foundation of a healthy society.",
  poem: `پسر چون به دنیا نیاید همی
بر او نام نیکو نشاید همی
چو در کودکی پرورش یابدش
به پیری ثمرها برآید خوشش`,
  analysis_fa: "شخصیت انسان از کودکی شکل می‌گیرد.",
  analysis_en: "Character is formed from early upbringing.",
  icon: "🌱"
},
{
  title: "گلستان – خاموشی",
  poet: "Saadi",
  poet_bio_fa: "سکوت عاقلانه در سخن سعدی ارزشمند است.",
  poet_bio_en: "Wise silence is valued in Saadi’s thought.",
  poem: `دو چیز طیره عقل است دم فروبستن
به وقت گفتن و گفتن به وقت خاموشی
ز گفتن آفت بسیار خیزد ای سعدی
به خامشی توانی زبان نگاه‌داشت`,
  analysis_fa: "کنترل زبان نشانه خرد است.",
  analysis_en: "Mastery of speech reflects wisdom.",
  icon: "🤫"
},
{
  title: "بوستان – عدالت",
  poet: "Saadi",
  poet_bio_fa: "عدالت اجتماعی یکی از ارکان فکری سعدی است.",
  poet_bio_en: "Social justice is central to Saadi’s worldview.",
  poem: `رعیت چو بیخ‌اند و سلطان درخت
درخت ای پسر باشد از بیخ سخت
چو بیخ از درختی بگردد تباه
نماند ز شاخش برویی گیاه`,
  analysis_fa: "پایداری حکومت وابسته به عدالت است.",
  analysis_en: "A ruler’s stability depends on justice.",
  icon: "⚖️"
},
{
  title: "رباعیات – ناپایداری",
  poet: "Khayyam",
  poet_bio_fa: "عمر خیام شاعر و فیلسوف قرن پنجم هجری با نگاهی عقل‌گرا و شکاک است.",
  poet_bio_en: "Khayyam was an 11th-century philosopher-poet with a rational and skeptical outlook.",
  poem: `ابر آمد و باز بر سر سبزه گریست
بی باده گلرنگ نمی‌باید زیست
این سبزه که امروز تماشاگه ماست
تا سبزه خاک ما تماشاگه کیست`,
  analysis_fa: "زندگی کوتاه و گذرا تصویر می‌شود.",
  analysis_en: "Life is portrayed as brief and transient.",
  icon: "⏳"
},
{
  title: "رباعیات – دم را دریاب",
  poet: "Khayyam",
  poet_bio_fa: "خیام بر زیستن در لحظه تأکید دارد.",
  poet_bio_en: "Khayyam emphasizes living in the present.",
  poem: `برخیز و بیا بتا که جان بگذرد
وانگه ز پیاله باده جان پرورد
این یک دم عمر را غنیمت دان
کز حاصل عمر جز همین دم نبرد`,
  analysis_fa: "حال تنها سرمایه انسان است.",
  analysis_en: "The present moment is life’s only certainty.",
  icon: "🍷"
},
{
  title: "رباعیات – شک",
  poet: "Khayyam",
  poet_bio_fa: "شک فلسفی بخش مهمی از جهان‌بینی خیام است.",
  poet_bio_en: "Philosophical doubt is central to Khayyam’s thought.",
  poem: `دارنده چو ترکیب طبایع آراست
از بهر چه افکندش اندر کم و کاست
گر نیک آمد شکستن از بهر چه بود
ور نیک نیامد این صور عیب که راست`,
  analysis_fa: "خیام آفرینش و سرنوشت را به پرسش می‌کشد.",
  analysis_en: "Khayyam questions creation and destiny.",
  icon: "❓"
},
{
  title: "رباعیات – مرگ",
  poet: "Khayyam",
  poet_bio_fa: "مرگ پایانی قطعی و بی‌پرده است.",
  poet_bio_en: "Death is a definitive and unavoidable end.",
  poem: `چون عاقبت کار جهان نیستی است
انگار که نیستی چو هستی خوش باش
می نوش که عمر جاودانی این است
خود حاصل عمر جاودانی این است`,
  analysis_fa: "مرگ معنا را به لحظه حال می‌دهد.",
  analysis_en: "Mortality gives meaning to the present.",
  icon: "⚰️"
},
{
  title: "رباعیات – سرنوشت",
  poet: "Khayyam",
  poet_bio_fa: "خیام تقدیر را تغییرناپذیر می‌بیند.",
  poet_bio_en: "Khayyam sees fate as unchangeable.",
  poem: `در دایره‌ای که آمدن و رفتن ماست
آن را نه بدایت نه نهایت پیداست
کس می‌نزند دمی در این عالم راست
کاین آمدن از کجا و رفتن به کجاست`,
  analysis_fa: "ابهام هستی محور تفکر خیام است.",
  analysis_en: "Existential ambiguity defines Khayyam’s worldview.",
  icon: "🌀"
},
{
  title: "منطق‌الطیر – سیمرغ",
  poet: "Attar",
  poet_bio_fa: "عطار نیشابوری شاعر و عارف قرن ششم هجری و صاحب اندیشه سلوک عرفانی است.",
  poet_bio_en: "Attar was a 12th-century Persian mystic poet known for spiritual allegories.",
  poem: `چون شما سی مرغ اینجا آمدید
خود سیمرغ شما بودید
در شما بود آنچه می‌جستید
خویش را چون دیدید، ره رستید`,
  analysis_fa: "حقیقت در خودشناسی جمعی نهفته است.",
  analysis_en: "Truth lies in collective self-realization.",
  icon: "🕊️"
},
{
  title: "الهی‌نامه – عشق",
  poet: "Attar",
  poet_bio_fa: "عشق محور سلوک عرفانی عطار است.",
  poet_bio_en: "Love is central to Attar’s mysticism.",
  poem: `عشق آمد و عقل را به کنجی بنشاند
جان را ز قفس رهاند و بالا رساند
هر جا که قدم نهاد آتش افکند
هر چیز که بود غیر او را بسوزاند`,
  analysis_fa: "عشق عقل محدود را کنار می‌زند.",
  analysis_en: "Love transcends and overcomes reason.",
  icon: "🔥"
},
{
  title: "منطق‌الطیر – فنا",
  poet: "Attar",
  poet_bio_fa: "فنا در حق نهایت سلوک است.",
  poet_bio_en: "Annihilation in God is the ultimate goal.",
  poem: `تا در فنا قدم ننهد سالک راه
کی یابد از این حقیقت آگاهی
چون قطره شوی فنا در آن بحر وجود
آنگه شودت نصیب شاهی الهی`,
  analysis_fa: "خودمحوی شرط وصال است.",
  analysis_en: "Self-annihilation enables union.",
  icon: "🌊"
},
{
  title: "اسرارنامه – خودشناسی",
  poet: "Attar",
  poet_bio_fa: "شناخت نفس مقدمه شناخت حق است.",
  poet_bio_en: "Knowing the self precedes knowing God.",
  poem: `تو خود گنجی و خود از خویش دوری
به هر سو می‌دوی در جست‌وجویی
چو در خود بنگری آن گنج یابی
که عمری در پی‌اش در های و هویی`,
  analysis_fa: "انسان حقیقت را بیرون از خود می‌جوید.",
  analysis_en: "Humans search outward for inner truth.",
  icon: "💎"
},
{
  title: "مصیبت‌نامه – رنج",
  poet: "Attar",
  poet_bio_fa: "رنج ابزار تعالی روح است.",
  poet_bio_en: "Suffering refines the soul.",
  poem: `تا در بلا نیفتد جان آدمی
کی پخته شود ز خامی هر دمی
این رنج که می‌کشی به راه طلب
نردبان توست سوی عالم کمی`,
  analysis_fa: "رنج لازمه رشد معنوی است.",
  analysis_en: "Suffering is essential for spiritual growth.",
  icon: "🧗"
},
{
  title: "مخزن‌الاسرار – حکمت",
  poet: "Nezami",
  poet_bio_fa: "نظامی گنجوی شاعر قرن ششم هجری و استاد داستان‌پردازی منظوم است.",
  poet_bio_en: "Nezami was a 12th-century Persian poet renowned for narrative poetry.",
  poem: `جهان چون خط و خال و چشم و ابروست
که هر چیزی به جای خویش نیکوست
اگر یک ذره از جای خود رود
نماند آن حسن کز اول وجود`,
  analysis_fa: "نظام هستی مبتنی بر تعادل است.",
  analysis_en: "Cosmic order depends on balance.",
  icon: "⚖️"
},
{
  title: "لیلی و مجنون – عشق",
  poet: "Nezami",
  poet_bio_fa: "نظامی عشق را نیروی ویرانگر و سازنده می‌داند.",
  poet_bio_en: "Nezami portrays love as both destructive and creative.",
  poem: `عشق آمد و آتش به جانم زد
خاکم به هوا و آسمانم زد
از من همه منی به یک سو برد
نامم به جهان جاودانم زد`,
  analysis_fa: "عشق هویت انسان را دگرگون می‌کند.",
  analysis_en: "Love transforms human identity.",
  icon: "❤️"
},
{
  title: "خسرو و شیرین – وفاداری",
  poet: "Nezami",
  poet_bio_fa: "وفاداری رکن عشق حقیقی است.",
  poet_bio_en: "Loyalty is essential to true love.",
  poem: `وفا آن بود کز نخستین قدم
نیاید به دل جز همان عهد هم
دل آن به که بر عهد خود پایدار
نلغزد ز راه وفا روزگار`,
  analysis_fa: "پایداری شرط عشق راستین است.",
  analysis_en: "Constancy defines true love.",
  icon: "🛡️"
},
{
  title: "هفت‌پیکر – سرنوشت",
  poet: "Nezami",
  poet_bio_fa: "نظامی تقدیر را در پیوند با خرد می‌بیند.",
  poet_bio_en: "Nezami links fate with wisdom.",
  poem: `چرخ از پی بازی است نه از پی کین
گر نیک شوی نیکی آید قرین
هر آن کس که خرد را رها کرد و رفت
به دست قضا شد گرفتار دین`,
  analysis_fa: "خرد سپر انسان در برابر قضاست.",
  analysis_en: "Wisdom shields against blind fate.",
  icon: "🌀"
},
{
  title: "اسکندرنامه – دانش",
  poet: "Nezami",
  poet_bio_fa: "دانش برتر از قدرت نظامی است.",
  poet_bio_en: "Knowledge surpasses military power.",
  poem: `نه شمشیر ماند نه تاج و کلاه
بماند خرد جاودان در نگاه
جهان را به دانش توان فتح کرد
نه با زور بازو و خون و نبرد`,
  analysis_fa: "فتح حقیقی با دانایی است.",
  analysis_en: "True conquest is achieved through knowledge.",
  icon: "📘"
},
{
  title: "حدیقه – بیداری",
  poet: "Sanai",
  poet_bio_fa: "سنایی غزنوی شاعر قرن ششم هجری و پیشگام شعر عرفانی تعلیمی است.",
  poet_bio_en: "Sanai was a 12th-century Persian poet and pioneer of didactic mysticism.",
  poem: `ای خفته به زیر لحاف غفلت
تا کی کنی از جهان تو حیرت
برخیز و ببین حقیقت خویش
کز خواب گران شوی سلامت`,
  analysis_fa: "بیداری معنوی هدف شعر سنایی است.",
  analysis_en: "Spiritual awakening is Sanai’s aim.",
  icon: "⏰"
},
{
  title: "حدیقه – دنیا",
  poet: "Sanai",
  poet_bio_fa: "سنایی دنیا را محل فریب می‌داند.",
  poet_bio_en: "Sanai views the world as deceptive.",
  poem: `این دنیا چو مار خوش‌خط و خال است
در زیر خوشی هزار نیش و وبال است
آن را که فریفته شود زین جمال
آخر به هلاکت افتد و زوال است`,
  analysis_fa: "ظاهر دنیا فریبنده است.",
  analysis_en: "Worldly beauty conceals danger.",
  icon: "🐍"
},
{
  title: "حدیقه – عقل",
  poet: "Sanai",
  poet_bio_fa: "عقل راهنمای دینداری آگاهانه است.",
  poet_bio_en: "Reason guides conscious faith.",
  poem: `دین بی‌خردی فتنه و آفت بود
عقل است که دین را شرافت بود
هر جا که خرد چراغ راه آمد
آن دین ز همه گزند راحت بود`,
  analysis_fa: "دینداری بدون عقل خطرناک است.",
  analysis_en: "Faith without reason is dangerous.",
  icon: "🧠"
},
{
  title: "حدیقه – نفس",
  poet: "Sanai",
  poet_bio_fa: "مبارزه با نفس محور سلوک است.",
  poet_bio_en: "Struggle with the ego is central to the path.",
  poem: `نفس تو چو دشمن است در خانه
هر لحظه کشاندت به بیگانه
تا نفس به تیغ صبر نکشی
هرگز نرسی به سوی جانانه`,
  analysis_fa: "تزکیه نفس شرط رهایی است.",
  analysis_en: "Purifying the ego enables liberation.",
  icon: "⚔️"
},
{
  title: "حدیقه – حقیقت",
  poet: "Sanai",
  poet_bio_fa: "حقیقت با رنج و مجاهده به دست می‌آید.",
  poet_bio_en: "Truth is attained through struggle.",
  poem: `راه حقیقت پر از خار و خون است
آن کس رود این ره که مرد جنون است
آسان طلبی مکن ز این مسیر
کز گنج حقیقت رهش سخت و دون است`,
  analysis_fa: "حقیقت نیازمند جسارت روحی است.",
  analysis_en: "Truth demands spiritual courage.",
  icon: "🧭"
},
{
  title: "اشک یتیم",
  poet: "Parvin Etesami",
  poet_bio_fa: "پروین اعتصامی شاعر برجسته معاصر با رویکرد اخلاقی، اجتماعی و تمثیلی است.",
  poet_bio_en: "Parvin Etesami was a modern Persian poet known for moral, social, and allegorical poetry.",
  poem: `کودکی دیدم ز درد فقر گریان در گذر
اشک می‌ریخت و همی‌گفتا خدا را دادگر
گفت از این دنیا چه دیدی ای کودک ژنده‌پوش
گفت جز اندوه و رنج و وعده‌های بی‌اثر`,
  analysis_fa: "پروین با زبان ساده، بی‌عدالتی اجتماعی را نقد می‌کند.",
  analysis_en: "Parvin critiques social injustice through simple yet powerful language.",
  icon: "🕯️"
},
{
  title: "گنج عفت",
  poet: "Parvin Etesami",
  poet_bio_fa: "پروین بر ارزش‌های اخلاقی و کرامت انسانی تأکید دارد.",
  poet_bio_en: "Parvin emphasizes moral values and human dignity.",
  poem: `زن در ایران پیش از این گویی که ایرانی نبود
پیشه‌اش جز تیره‌روزی و پریشانی نبود
زندگی و مرگش اندر کنج عزلت می‌گذشت
زن چه بود آن روزها گر زآنکه زندانی نبود`,
  analysis_fa: "شعر به وضعیت تاریخی زنان می‌پردازد.",
  analysis_en: "The poem addresses the historical oppression of women.",
  icon: "⚖️"
},
{
  title: "قطره و دریا",
  poet: "Parvin Etesami",
  poet_bio_fa: "تمثیل ابزار اصلی بیان اندیشه پروین است.",
  poet_bio_en: "Allegory is Parvin’s primary expressive tool.",
  poem: `قطره‌ای گفت به دریا که مرا هست غرور
گفت خاموش که تو قطره‌ای و من پرنور
هر که خود را بشناسد به حقیقت برسد
قطره چون قطره بماند نشود بحر ز دور`,
  analysis_fa: "خودشناسی شرط تعالی انسان معرفی می‌شود.",
  analysis_en: "Self-knowledge is presented as the path to growth.",
  icon: "💧"
},
{
  title: "رنجبر",
  poet: "Parvin Etesami",
  poet_bio_fa: "درد طبقات فرودست در شعر پروین برجسته است.",
  poet_bio_en: "The suffering of the lower classes is central to Parvin’s poetry.",
  poem: `دیدم به رهی مردی از رنج خمیده
چهره ز غبار غم و محنت پریده
گفتا که مرا رنج، رفیق شب و روز است
این است نصیب من ز این سفره چریده`,
  analysis_fa: "شعر همدلی با رنجبران جامعه است.",
  analysis_en: "The poem expresses empathy with laborers.",
  icon: "🧱"
},
{
  title: "آیینه",
  poet: "Parvin Etesami",
  poet_bio_fa: "خودانتقادی اخلاقی در شعر پروین پررنگ است.",
  poet_bio_en: "Moral self-criticism is prominent in Parvin’s work.",
  poem: `آیینه گفتا که عیب تو کجاست
گفتم که مرا ز عیب خود آگاهی است
گفتا که چو خود را نبینی به درست
هرگز نرسد کارت به نیک‌خواهی است`,
  analysis_fa: "اصلاح فردی مقدم بر اصلاح اجتماعی است.",
  analysis_en: "Personal reform precedes social reform.",
  icon: "🪞"
},
{
  title: "ققنوس",
  poet: "Nima Yooshij",
  poet_bio_fa: "نیما یوشیج بنیان‌گذار شعر نو فارسی و شاعر تحول‌خواه معاصر است.",
  poet_bio_en: "Nima Yooshij was the founder of modern Persian free verse poetry.",
  poem: `خانه‌ام ابری است
یکسره روی زمین ابری است با آن
از فراز گردنه خرد و خراب و مست
باد می‌پیچد`,
  analysis_fa: "فضای شعر نماد آشفتگی اجتماعی و درونی است.",
  analysis_en: "The atmosphere symbolizes social and inner turmoil.",
  icon: "🌫️"
},
{
  title: "افسانه",
  poet: "Nima Yooshij",
  poet_bio_fa: "افسانه مانیفست شعر نو فارسی است.",
  poet_bio_en: "Afsaneh is considered the manifesto of modern Persian poetry.",
  poem: `تو را من چشم در راهم
شباهنگام
که می‌گیرند در شاخ تلاجن سایه‌ها رنگ سیاهی`,
  analysis_fa: "انتظار و تنهایی در قالبی نو بیان می‌شود.",
  analysis_en: "Waiting and solitude are expressed in a new poetic form.",
  icon: "🌙"
},
{
  title: "ای شب",
  poet: "Nima Yooshij",
  poet_bio_fa: "شب در شعر نیما نماد اختناق و سکوت است.",
  poet_bio_en: "Night symbolizes silence and oppression in Nima’s poetry.",
  poem: `ای شب
ای چشم تو روزن ظلمت
ای پرده‌ی راز`,
  analysis_fa: "فضای تیره بازتاب شرایط اجتماعی است.",
  analysis_en: "Darkness reflects social conditions.",
  icon: "🌑"
},
{
  title: "داروگ",
  poet: "Nima Yooshij",
  poet_bio_fa: "داروگ نماد امید در دل تاریکی است.",
  poet_bio_en: "Daroug symbolizes hope amid darkness.",
  poem: `داروگ!
کی می‌رسد باران؟
بر خشک‌زار سینه من`,
  analysis_fa: "باران استعاره‌ای از رهایی است.",
  analysis_en: "Rain symbolizes liberation.",
  icon: "🌧️"
},
{
  title: "مرغ آمین",
  poet: "Nima Yooshij",
  poet_bio_fa: "این شعر بیانگر آرزوی جمعی رهایی است.",
  poet_bio_en: "The poem expresses a collective wish for freedom.",
  poem: `مرغ آمین
دردآلودی‌ست
که می‌خواند`,
  analysis_fa: "شعر صدای امید خاموش جامعه است.",
  analysis_en: "The poem voices muted social hope.",
  icon: "🕊️"
},
{
  title: "صدای پای آب",
  poet: "Sohrab Sepehri",
  poet_bio_fa: "سهراب سپهری شاعر و نقاش معاصر با نگاه عرفانی و طبیعت‌محور است.",
  poet_bio_en: "Sohrab Sepehri was a modern poet and painter with a mystical, nature-centered worldview.",
  poem: `اهل کاشانم
پیشه‌ام نقاشی است
گاه‌گاهی قفسی می‌سازم
با رنگ، می‌فروشم به شما`,
  analysis_fa: "شعر بیان هویت شخصی و نگاه هنرمندانه به جهان است.",
  analysis_en: "The poem expresses personal identity and artistic worldview.",
  icon: "🎨"
},
{
  title: "آب را گل نکنیم",
  poet: "Sohrab Sepehri",
  poet_bio_fa: "سهراب بر سادگی و پاکی تأکید دارد.",
  poet_bio_en: "Sohrab emphasizes purity and simplicity.",
  poem: `آب را گل نکنیم
در فرودست انگار کفتری می‌خورد آب
یا که در بیشه‌ای دور
سیره‌ای پر می‌شوید`,
  analysis_fa: "شعر دعوت به حفظ پاکی طبیعت و روح است.",
  analysis_en: "The poem calls for preserving natural and spiritual purity.",
  icon: "💧"
},
{
  title: "مسافر",
  poet: "Sohrab Sepehri",
  poet_bio_fa: "سفر نماد جست‌وجوی درونی در شعر سهراب است.",
  poet_bio_en: "Journey symbolizes inner search in Sohrab’s poetry.",
  poem: `من مسافرم
باید بروم
پشت دریاها شهری است
که در آن پنجره‌ها رو به تجلی باز است`,
  analysis_fa: "حرکت به سوی آگاهی مطرح می‌شود.",
  analysis_en: "Movement toward awareness is emphasized.",
  icon: "🚶"
},
{
  title: "نشانی",
  poet: "Sohrab Sepehri",
  poet_bio_fa: "سهراب معنا را در سادگی می‌جوید.",
  poet_bio_en: "Sohrab seeks meaning in simplicity.",
  poem: `خانه دوست کجاست؟
در فلق بود که پرسید سوار
آسمان مکثی کرد
رهگذر شاخه نوری که به لب داشت به تاریکی شن‌ها بخشید`,
  analysis_fa: "دوست نماد حقیقت است.",
  analysis_en: "The friend symbolizes truth.",
  icon: "✨"
},
{
  title: "حجم سبز",
  poet: "Sohrab Sepehri",
  poet_bio_fa: "طبیعت عنصر مرکزی شعر سهراب است.",
  poet_bio_en: "Nature is central to Sohrab’s poetry.",
  poem: `چشم‌ها را باید شست
جور دیگر باید دید
واژه باید خود باد
واژه باید خود باران باشد`,
  analysis_fa: "دگرگونی نگاه شرط درک جهان است.",
  analysis_en: "Changing perspective enables understanding.",
  icon: "🌱"
},
{
  title: "بازآمد بوی ماه مدرسه",
  poet: "Rudaki",
  poet_bio_fa: "رودکی پدر شعر فارسی و شاعر قرن سوم و چهارم هجری است که زبان ساده و موسیقایی دارد.",
  poet_bio_en: "Rudaki was the father of Persian poetry, known for clarity and musicality.",
  poem: `بازآمد بوی ماه مدرسه
بازآمد بوی یار آشنا
ای یار سفرکرده کجایی کجایی
ای دلبر آزرده چرا بی‌وفا`,
  analysis_fa: "دلتنگی و عشق انسانی با زبانی ساده و مستقیم بیان شده است.",
  analysis_en: "Longing and human love are expressed with simplicity and clarity.",
  icon: "🌸"
},
{
  title: "شاد زی",
  poet: "Rudaki",
  poet_bio_fa: "نگاه رودکی به زندگی واقع‌گرایانه و شادی‌محور است.",
  poet_bio_en: "Rudaki promotes a realistic, joy-centered view of life.",
  poem: `شاد زی با سیه‌چشمان شاد
که جهان نیست جز فسانه و باد
ز آمده شادمان بباید بود
وز گذشته نکرد باید یاد`,
  analysis_fa: "زندگی کوتاه است و شادی ارزشمند.",
  analysis_en: "Life is fleeting; joy is essential.",
  icon: "☀️"
},
{
  title: "دلبری",
  poet: "Rudaki",
  poet_bio_fa: "عشق زمینی در شعر رودکی بی‌پیرایه است.",
  poet_bio_en: "Earthly love in Rudaki is direct and unembellished.",
  poem: `دل من شد گرفتار آن دو چشم
چون شدم عاشقش از خویش برفتم
به یک خنده ببرد از دل من هوش
به یک ناز مرا زنده و کشت`,
  analysis_fa: "عشق ناگهانی و تاثیرگذار تصویر می‌شود.",
  analysis_en: "Love is sudden and overwhelming.",
  icon: "❤️"
},
{
  title: "پیری",
  poet: "Rudaki",
  poet_bio_fa: "رودکی به گذر عمر آگاه است.",
  poet_bio_en: "Rudaki reflects on aging and time.",
  poem: `مرا بسود و فرو ریخت هر چه دندان بود
نبود دندان، لابل چراغ تابان بود
سپید شد موی و از پیری افتادم
جوانی رفت و ندانستمش که چونان بود`,
  analysis_fa: "حسرت جوانی و آگاهی از زمان.",
  analysis_en: "Awareness of time and lost youth.",
  icon: "⏳"
},
{
  title: "دل‌آرام",
  poet: "Rudaki",
  poet_bio_fa: "دلبر محور عاطفی شعر رودکی است.",
  poet_bio_en: "The beloved is central to Rudaki’s emotion.",
  poem: `دل‌آرامی مرا آرام جان شد
غمش شادی و دردش را درمان شد
اگر بی‌او نفس آید به سختی
به دیدارش نفس آسان شد`,
  analysis_fa: "عشق منبع آرامش روح است.",
  analysis_en: "Love brings inner peace.",
  icon: "💞"
},
{
  title: "یوسف و زلیخا – عشق",
  poet: "Jami",
  poet_bio_fa: "جامی شاعر و عارف قرن نهم هجری با پیوند عشق زمینی و الهی است.",
  poet_bio_en: "Jami was a 15th-century poet blending earthly and divine love.",
  poem: `عشق آمد و آتش به دل افروخت
جان را ز قفس سوی فلک دوخت
هر جا که نشان از من و ما بود
عشق آمد و آن جمله فرو سوخت`,
  analysis_fa: "عشق مرز میان انسان و حقیقت را می‌سوزاند.",
  analysis_en: "Love dissolves the boundary between human and truth.",
  icon: "🔥"
},
{
  title: "بهار عشق",
  poet: "Jami",
  poet_bio_fa: "طبیعت در شعر جامی نماد شکوفایی عشق است.",
  poet_bio_en: "Nature symbolizes the blossoming of love in Jami.",
  poem: `بهار آمد که هر شاخی جوان شد
زمین آیینه‌دار آسمان شد
دلم چون غنچه از عشق تو بشکفت
جهان بی‌روی تو زندان جان شد`,
  analysis_fa: "عشق با بهار هم‌معنا می‌شود.",
  analysis_en: "Love parallels the arrival of spring.",
  icon: "🌷"
},
{
  title: "وصل",
  poet: "Jami",
  poet_bio_fa: "وصال نهایت سلوک عاشقانه است.",
  poet_bio_en: "Union is the culmination of love’s journey.",
  poem: `چو دیدم روی تو آرام جان را
فراموش آمدم هر دو جهان را
نه دنیا ماند و نه سودای عقبی
چو یافتم آن نگار مهربان را`,
  analysis_fa: "وصال فراتر از دنیا و آخرت است.",
  analysis_en: "Union transcends both worlds.",
  icon: "✨"
},
{
  title: "فراق",
  poet: "Jami",
  poet_bio_fa: "فراق آزمون صدق عشق است.",
  poet_bio_en: "Separation tests true love.",
  poem: `ز هجرانت دلم چون شمع سوزان
همی‌سوزد شبان‌روزان نهان
اگرچه دوری‌ات آتش به جان زد
امید وصل دارم جاودان`,
  analysis_fa: "امید، رنج فراق را قابل تحمل می‌کند.",
  analysis_en: "Hope softens the pain of separation.",
  icon: "🕯️"
},
{
  title: "آینه دل",
  poet: "Jami",
  poet_bio_fa: "دل عاشق آینه جمال محبوب است.",
  poet_bio_en: "The lover’s heart reflects the beloved.",
  poem: `دل آینه‌دار روی جانان شد
ز غیر او همه عالم نهان شد
چو صیقل خورد دل از عشق نابش
جهان در چشم ما نورافشان شد`,
  analysis_fa: "پاکی دل شرط دیدن حقیقت است.",
  analysis_en: "Purity of heart enables vision of truth.",
  icon: "🪞"
},
{
  title: "اسیر",
  poet: "Forough Farrokhzad",
  poet_bio_fa: "فروغ فرخزاد شاعر معاصر با صدای زنانه، جسور و شخصی است.",
  poet_bio_en: "Forough Farrokhzad was a bold modern poet with an intimate female voice.",
  poem: `من از اسارت عشق تو می‌نالم
ولی هنوز به زنجیر تو دل‌بستم
تو با نگاهت مرا به بند کشیدی
و من به این بند عاشقانه خرسندم`,
  analysis_fa: "عشق هم‌زمان رهایی و اسارت است.",
  analysis_en: "Love is both captivity and desire.",
  icon: "🖤"
},
{
  title: "تولدی دیگر",
  poet: "Forough Farrokhzad",
  poet_bio_fa: "عشق در شعر فروغ عامل باززایی است.",
  poet_bio_en: "Love becomes rebirth in Forough’s poetry.",
  poem: `همه هستی من آیه تاریکی‌ست
که تو را در خود تکرارکنان می‌برد
به سحرگاه شکفتن‌ها و رستن‌های ابدی
به آغوش کشیدن‌های بی‌پایان`,
  analysis_fa: "عشق تجربه‌ای وجودی و دگرگون‌کننده است.",
  analysis_en: "Love is an existential transformation.",
  icon: "🌑"
},
{
  title: "عشق",
  poet: "Forough Farrokhzad",
  poet_bio_fa: "بی‌پروایی عاطفی ویژگی شعر فروغ است.",
  poet_bio_en: "Emotional boldness defines Forough’s poetry.",
  poem: `دوستت دارم
و این دوست داشتن
حقیقتی است
که از من فراتر می‌رود`,
  analysis_fa: "عشق به‌مثابه حقیقتی مستقل.",
  analysis_en: "Love exists beyond the self.",
  icon: "❤️"
},
{
  title: "پاییز",
  poet: "Forough Farrokhzad",
  poet_bio_fa: "پاییز نماد پایان و بلوغ است.",
  poet_bio_en: "Autumn symbolizes maturity and endings.",
  poem: `پاییز
فصل درک حضور
برگ‌هایی است
که عشق را به زمین می‌آورند`,
  analysis_fa: "عشق با فقدان آمیخته است.",
  analysis_en: "Love intertwines with loss.",
  icon: "🍂"
},
{
  title: "یاد تو",
  poet: "Forough Farrokhzad",
  poet_bio_fa: "یاد محبوب حضوری مداوم دارد.",
  poet_bio_en: "Memory of the beloved is constant.",
  poem: `تو رفته‌ای
اما نامت هنوز
در نبض شب
با قلب من می‌تپد`,
  analysis_fa: "عشق فراتر از حضور فیزیکی است.",
  analysis_en: "Love transcends physical presence.",
  icon: "💔"
}


]
